module.exports = __webpack_public_path__ + "img/AirtelDTH.a0584f87.png";